import qs from 'qs';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { Meta } from '../communication/types/Meta';
import { ProviderAvailability } from './types/ProviderAvailability';

export interface ListProviderAvailabilitiesResponse {
  nodes: ProviderAvailability[];
  total: number;
  meta: Meta;
}

export interface ListProviderAvailabilities {
  user_id: number;
  type?: string;
  limit?: number;
  cursor?: string;
  cursor_direction?: 'next' | 'previous';
}

export const listUserAvailabilities = async (
  user_id: number,
  params?: ListProviderAvailabilities,
  userRole?: string,
): Promise<ListProviderAvailabilitiesResponse> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.get(
    `${prefix}/users/${user_id}/user_availability?${qs.stringify(params, { skipNulls: true })}`,
  );
  return data;
};
